module.exports = __webpack_public_path__ + "static/media/Ellipse 7.f36c33fc.svg";